import { UserProfile } from '../Components/UserProfile'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/**
 * «Мій профіль» — `Setting.Profile`, адреса `/profile`, як у легасі (ключ
 * виводить ядро, `SPEC-002` §2.2; шлях задано явно — ядро вивело б
 * `/setting/profile`). Відкривається з шапки — меню блоку користувача;
 * у боковому меню пункту немає.
 *
 * Профіль у проєкті один: другий профіль еталона (`Setting.UserProfile`, лише
 * пряма адреса) прибрано (`SPEC-005` §3.7).
 */
export default function ProfilePage() {
    return <UserProfile />
}

export const pageConfig: IPageConfig = {
    title: 'Мій профіль',
    route: '/profile',
}
